// src/pages/SmarthomePage.js
import { useSelector } from "react-redux";
import HeroSection from "./smarthome/sections/1-HeroSection";
import FeaturesSection from "./smarthome/sections/2-FeaturesSection";
import ContactUs from "./smarthome/sections/3-ContactUs";
import AppSection from "./smarthome/sections/4-AppSection";
import HeatingSection from "./smarthome/sections/5-HeatingSection";
import EnergySection from "./smarthome/sections/6-EnergySection";
import EdgeComputingSection from "./smarthome/sections/11-EdgeComputingSection";
import SmartSection from "./smarthome/sections/7-SmartSection";
import SecuritySection from "./smarthome/sections/8-SecuritySection";
import ReuseExistingSection from "./smarthome/sections/9-ReuseExistingSection";
import ProductSection from "./smarthome/sections/10-ProductsSection";
import UsersRolesSection from "./smarthome/sections/12-UsersRolesSection";
import InstallationSection from "./smarthome/sections/13-InstallationSection";
import textContentSmarthomeHeroSection from "./smarthome/ui/textContent-smarthome-HeroSection";
import textContentSmarthomeFeaturesSection from "./smarthome/ui/textContent-smarthome-FeaturesSection";
import textContentSmarthomeContactUsSection from "./smarthome/ui/textContent-smarthome-contactUsSection";
import textContentSmarthomeAppSection from "./smarthome/ui/textContent-smarthome-appSection";
import textContentSmarthomeHeatingSection from "./smarthome/ui/textContent-smarthome-heatingSection";
import textContentSmarthomeEnergySection from "./smarthome/ui/textContent-smarthome-energySection";
import textContentSmarthomeSmartSection from "./smarthome/ui/textContent-smarthome-SmartSection";
import textContentSmarthomeSecuritySection from "./smarthome/ui/textContent-smarthome-SecuritySection";
import textContentSmarthomeProductSection from "./smarthome/ui/textContent-smarthome-ProductSection";
import textContentSmarthomeEdgeComputingSection from "./smarthome/ui/textContent-smarthome-edgeComputingSection";
import textContentSmarthomeUserRoles from "./smarthome/ui/textContent-smarthome-userRoles";
import textContentSmarthomeInstallationSection from "./smarthome/ui/textContent-smarthome-installationSection";

function SmarthomePage() {
  const language = useSelector((state) => state.dictionary.language);
  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <>
      <HeroSection
        textContent={textContentSmarthomeHeroSection}
        language={language}
      />
      <div className="container-empty-medium" />
      <FeaturesSection
        textContent={textContentSmarthomeFeaturesSection}
        language={language}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-medium"
        }
      />
      <div className={isMobile ? "container-empty-small" : ""} />
      <ContactUs
        textContent={textContentSmarthomeContactUsSection}
        language={language}
      />
      {!isMobile ? <div className={"container-empty-medium"} /> : null}

      <AppSection
        language={language}
        textContent={textContentSmarthomeAppSection}
      />

      <HeatingSection
        textContent={textContentSmarthomeHeatingSection}
        language={language}
      />

      <div
        className={
          !isMobile
            ? "container-empty-medium section-background-grey"
            : "container-empty-medium section-background-grey"
        }
      />
      <div
        className={
          !isMobile ? "" : "container-empty-medium section-background-grey"
        }
      />
      <EnergySection
        language={language}
        textContent={textContentSmarthomeEnergySection}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-small"
        }
      />

      <ContactUs
        textContent={textContentSmarthomeContactUsSection}
        language={language}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-medium"
        }
      />
      <div className={isMobile ? "container-empty-small" : ""} />
      <SmartSection
        language={language}
        textContent={textContentSmarthomeSmartSection}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-large"
        }
      />
      <div className={isMobile ? "container-empty-small" : ""} />
      <ContactUs
        textContent={textContentSmarthomeContactUsSection}
        language={language}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-medium"
        }
      />
      <div className={isMobile ? "container-empty-small" : ""} />
      <SecuritySection
        textContent={textContentSmarthomeSecuritySection}
        language={language}
      />
      <div
        className={
          !isMobile ? "container-empty-small" : "container-empty-medium"
        }
      />

      <ReuseExistingSection
        language={language}
        textContent={textContentSmarthomeProductSection}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-extra-small"
        }
      />
      <ProductSection
        language={language}
        textContent={textContentSmarthomeProductSection}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-small"
        }
      />
      <EdgeComputingSection
        language={language}
        textContent={textContentSmarthomeEdgeComputingSection}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-medium"
        }
      />
      <UsersRolesSection
        language={language}
        textContent={textContentSmarthomeUserRoles}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-medium"
        }
      />
      {isMobile ? (
        <ContactUs
          textContent={textContentSmarthomeContactUsSection}
          language={language}
        />
      ) : null}
      <div className={isMobile ? "container-empty-medium" : ""} />
      <InstallationSection
        language={language}
        textContent={textContentSmarthomeInstallationSection}
      />
    </>
  );
}

export default SmarthomePage;
